import { useInt } from 'hooks/useInt';

import { Section } from 'ui/molecules/Section/Section';

import styles from './CompanyDataStatement.module.scss';

export const CompanyDataStatement = () => {
  const { t } = useInt();

  return (
    <Section
      className={styles.root}
      layout="split"
      splitAlign="top"
      extra={t('the problem with recall')}
      title={t('An agent that cannot show its source is a liability with good grammar.')}
    >
      <div className={styles.copy}>
        <p>
          {t(
            'General-purpose models produce a turnover figure for any company you name. It is fluent, plausible and unattached to a filing. Put that in a case file and the first question an examiner asks is the one the agent cannot answer.',
          )}
        </p>
        <p>
          {t(
            'This is company data for AI agents built so the agent never has to. Every record an enterprise AI agent retrieves is read from a named government register and returned with the reference a reviewer needs to open the original. 400+ registries, 200+ countries and territories, 600M+ company records, synced daily.',
          )}
        </p>
      </div>
    </Section>
  );
};
